<template>
  <div>
    <v-sheet
      color="white"
      class="px-4 py-3 mb-4"
    >
      <!-- <div class="ml-n2">
        <v-btn
          icon
          @click="$emit('finish')"
        >
          <v-icon>{{ mdiArrowLeft }}</v-icon>
        </v-btn>
      </div> -->

      <s-message-header :doc="item" />

      <br>

      <s-e-doc-provider-json-de :task="item" />

      <s-ancestor-process :process-id="item.dfProcessId" />

      <s-encrypted-viewer-staff
        v-if="item.securityLevelId && item.securityLevelId > 1"
        :opener-list="openerList"
        :security-level-id="item.securityLevelId"
      />

      <br>

      <s-instruction-and-more
        :instruction="item.senderInstruction"
        :prefill-info="prefillInfo"
        :sender-note="item.senderNote"
        :sender-euid="item.senderEuid"
        :sender-name="$chPtObjData('chinSenderName',item)"
      />

      <div
        v-if="!isShowSendToNextCard"
        class="d-flex mt-4"
      >
        <v-spacer />

        <s-transfer-process
          css-class="mr-2"
          :edoc="item"
          :doc-flow-status="status"
          :upload-file-url="uploadFileUrl"
          @back="closeCardAndBack"
        />

        <s-archive-process
          v-if="!canOnlyTransfer"
          :edoc="item"
          :doc-flow-status="status"
          :can-archive="canArchive"
          @back="closeCardAndBack"
        />

        <!-- 處理 -->
        <v-tooltip
          color="black"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!canOnlyTransfer"
              icon
              color="primary"
              class="v-btn--outlined-bold"
              v-bind="attrs"
              v-on="on"
              @click="showAndPrepareFileList()"
            >
              <v-icon>
                {{ mdiFountainPenTip }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('DocFlow.Instruction') }} / {{ $t('DocFlow.Instruction.B') }}</span>
        </v-tooltip>
      </div>

      <v-sheet
        v-if="isShowSendToNextCard"
        elevation="6"
        rounded
        class="mt-10 mx-n4 mb-n3 pb-4"
      >
        <v-toolbar
          dense
          flat
        >
          <v-toolbar-title class="text--body-1 mt-3">
            {{ $t('DocFlow.Instruction') }} / {{ $t('DocFlow.Instruction.B') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            class="mt-2"
            @click="isShowSendToNextCard = false"
          >
            <v-icon>{{ mdiClose }}</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="px-4 pt-3">
          <s-to-next-content
            :edoc="item"
            :upload-file-url="uploadFileUrl"
            :doc-flow-status="status"
            @closeCard="closeCardAndBack"
          />
          <!-- <div class="d-flex">
                <v-spacer />
                <v-btn
                  class="primary"
                  @click="forward"
                >
                  送出
                </v-btn>
              </div> -->
        </div>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>

import { momentWithHyphen } from '@/utils/datetimeUtil'
import { mdiArrowLeft, mdiRedo, mdiSend, mdiInformationOutline, mdiPencil, mdiClose, mdiFileCheckOutline, mdiFountainPenTip } from '@mdi/js'
import { docFlowMethod } from '@/mixins/docFlowMethod'
import { DOC_FLOW_STATUS } from '@/constant/constant'

import SEDocProviderJsonDe from './SEDocProviderJsonDe'
import SMessageHeader from './SMessageHeader'
import STransferProcess from './STransferProcess'
import SToNextContent from './SToNextContent'
import SAncestorProcess from './SAncestorProcess'
import SEncryptedViewerStaff from './SEncryptedViewerStaff.vue'
// import SClassPdfMuti from '@/components/SClassPdfMuti'

// import SSearchStaff from '@/components/SSearchStaff'
import docFlowApi from '@/api/eDocInternal/docFlow'
import SArchiveProcess from './SArchiveProcess.vue'
import SInstructionAndMore from './SInstructionAndMore.vue'
import { mapState } from 'vuex'
import { docFlowModule } from '@/store/moduleName'

export default {
  components: {
    SEDocProviderJsonDe,
    SMessageHeader,
    STransferProcess,
    SToNextContent,
    SArchiveProcess,
    SInstructionAndMore,
    SAncestorProcess,
    SEncryptedViewerStaff
  },
  mixins: [docFlowMethod],
  props: {
    item: {
      type: Object,
      default: null
    },
    canOnlyTransfer: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      mdiArrowLeft: mdiArrowLeft,
      mdiRedo: mdiRedo,
      mdiSend: mdiSend,
      mdiInformationOutline: mdiInformationOutline,
      mdiPencil: mdiPencil,
      mdiClose: mdiClose,
      mdiFountainPenTip,
      mdiFileCheckOutline: mdiFileCheckOutline,
      pdfDialog: false,
      fullHistoryDialog: false,
      maskAsCompleteDialog: false,
      ancestorProcess: [],
      isShowSendToNextCard: false,
      // files: [],
      uploadFileUrl: null,
      status: [DOC_FLOW_STATUS.WAITING],
      prefillInfo: null,
      // openerList: [],
      canArchive: true // Users isn't allowed to upload another documents for archiving if the edoc is encrypted
    }
  },
  computed: {
    ...mapState(docFlowModule, {
      taskListJobType: state => state.tasklistJobType,
      inflowStatus: state => state.inflowStatus
      // redirectPath: state => state.redirectPath
    })
  },
  async created () {
    this.uploadFileUrl = docFlowApi.uploadFileUrl
    await docFlowApi.getProcessPrefillInfo(this.item.dfProcessId, resp => {
      this.prefillInfo = resp.data
    })
    if (this.item.securityLevelId && this.item.securityLevelId > 1) {
      await this.$store.dispatch(docFlowModule + '/getOpenerList', this.item.dfProcessId)
    } else {
      this.$store.commit(docFlowModule + '/setOpenerList', []) // clear the opener list
    }
    if (this.openerList && this.openerList.length) {
      this.canArchive = false
    }
  },
  methods: {
    closeCardAndBack () {
      this.isShowSendToNextCard = false
      this.$emit('finish')
    },

    showAndPrepareFileList () {
      if (this.isMeOpener && !this.decryptedFileKey) {
        this.previewFileList(this.item.dfProcessId, false) // find the encrypted document and get the "encryptedFileKey". Then set the key into store 'commonComponent' for decrypting file.
      }
      this.isShowSendToNextCard = true
    },

    momentWithHyphen
  }
}
</script>
